import { render } from "./Separator.vue?vue&type=template&id=4623db74&scoped=true"
const script = {}

import "./Separator.vue?vue&type=style&index=0&id=4623db74&scoped=true&lang=css"

import exportComponent from "/vercel/path0/cv-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4623db74"]])

export default __exports__